export default __webpack_public_path__ + "static/media/Bracers of the Ascension.89400a41.jpg";